// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editor_CCGJ4 {
    min-height : 65vh;
    min-width : 65vw;
    position: relative;
  }

  .grid_jKyDn {
    display : grid;
    grid-template-columns: auto auto;
    column-gap : var( --size-padMedium, 16px );
    row-gap : var( --size-padMedium, 16px );
    align-items: center;
    justify-content: left;
  }
  
  .fill_uj4r3 {
    grid-column: 1 / span 2;
  }

  .pad_M_5GJ {
    padding : var( --size-padLarge, 16px )
  }

  .toggleFlex_JCreE {
    border : 1px solid var( --color-brand500 );
    border-radius: 4px;
  }`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/dataViewers/history/editors/HistoryViewEditor.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,gCAAgC;IAChC,0CAA0C;IAC1C,uCAAuC;IACvC,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE;EACF;;EAEA;IACE,0CAA0C;IAC1C,kBAAkB;EACpB","sourcesContent":[".editor {\n    min-height : 65vh;\n    min-width : 65vw;\n    position: relative;\n  }\n\n  .grid {\n    display : grid;\n    grid-template-columns: auto auto;\n    column-gap : var( --size-padMedium, 16px );\n    row-gap : var( --size-padMedium, 16px );\n    align-items: center;\n    justify-content: left;\n  }\n  \n  .fill {\n    grid-column: 1 / span 2;\n  }\n\n  .pad {\n    padding : var( --size-padLarge, 16px )\n  }\n\n  .toggleFlex {\n    border : 1px solid var( --color-brand500 );\n    border-radius: 4px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editor": `editor_CCGJ4`,
	"grid": `grid_jKyDn`,
	"fill": `fill_uj4r3`,
	"pad": `pad_M_5GJ`,
	"toggleFlex": `toggleFlex_JCreE`
};
export default ___CSS_LOADER_EXPORT___;
